<template>
  <div class="">
    <b-row>
      <b-col sm="12" md="6">
        <InputSelect
          title="Message Format"
          name="MessageFormat"
          isRequired
          :value="response.content.ReplyType"
          :options="replyTypeList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeType"
          :isValidate="v.content.ReplyType.$error"
          :v="v.content.ReplyType"
          />
      </b-col>
      <b-col sm="12" md="6">
        <InputText
          class=""
          textFloat="Sort Order"
          placeholder="0"
          type="number"
          name="sortOrder"
          v-model="response.sortOrder"
        />
      </b-col>
    </b-row>

    <!-- Type Text -->
    <template v-if="response.content.ReplyType === 1">
      <FormResponseType1 :response="response" :v="v" />
    </template>

    <!-- Type Text/Button -->
    <template v-if="response.content.ReplyType === 2">
      <FormResponseType2 :response="response" :v="v" />
    </template>

    <!-- Type Text/Image -->
    <template v-if="response.content.ReplyType === 3">
      <FormResponseType3 :response="response" :v="v" />
    </template>

    <!-- Type Image -->
    <template v-if="response.content.ReplyType === 4">
      <FormResponseType4
        :response="response"
        :languageActiveId="languageActiveId"
        :sameReplyAsNeutral="sameReplyAsNeutral"
        :v="v"
      />
    </template>

    <!-- Type Text/Image/Button -->
    <template v-if="response.content.ReplyType === 5">
      <FormResponseType5 :response="response" :v="v" />
    </template>

    <!-- Type Custom -->
    <template v-if="response.content.ReplyType === 6">
      <FormResponseType6 :response="response" />
    </template>

    <!-- Type Custom -->
    <template v-if="response.content.ReplyType === 17"> </template>

    <!-- Type Product Reply -->
    <template v-if="response.content.ReplyType === 10">
      <FormResponseType7 :response="response" :v="v" />
    </template>

    <!-- Type Condition -->
    <template v-if="response.content.ReplyType === 46">
      <FormResponseType8
        :response="response"
        :v="v"
        :conditionList="conditionList"
        :operationList="operationList"
        :allFirstFlowList="allFirstFlowList"
      />
    </template>

    <!-- Type User Input -->
    <template v-if="response.content.ReplyType === 47">
      <FormResponseType9 :response="response" :v="v" :conditionList="conditionList"/>
    </template>
    
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import FormResponseType1 from "@/views/pages/flow-builder/components/form-response/FormResponseType1";
import FormResponseType2 from "@/views/pages/flow-builder/components/form-response/FormResponseType2";
import FormResponseType3 from "@/views/pages/flow-builder/components/form-response/FormResponseType3";
import FormResponseType4 from "@/views/pages/flow-builder/components/form-response/FormResponseType4";
import FormResponseType5 from "@/views/pages/flow-builder/components/form-response/FormResponseType5";
import FormResponseType6 from "@/views/pages/flow-builder/components/form-response/FormResponseType6";
import FormResponseType7 from "@/views/pages/flow-builder/components/form-response/FormResponseType7";
import FormResponseType8 from "@/views/pages/flow-builder/components/form-response/FormResponseType8";
import FormResponseType9 from "@/views/pages/flow-builder/components/form-response/FormResponseType9";
export default {
  components: {
    InputText,
    InputSelect,
    FormResponseType1,
    FormResponseType2,
    FormResponseType3,
    FormResponseType4,
    FormResponseType5,
    FormResponseType6,
    FormResponseType7,
    FormResponseType8,
    FormResponseType9
  },
  props: {
    response: {
      required: true,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
    sameReplyAsNeutral: {
      required: false,
      type: Boolean,
    },
    conditionList: {
      required: true,
      type: Array,
    },
    allFirstFlowList: {
      required: true,
      type: Array,
    },
    operationList: {
      required: true,
      type: Array,
    },
    replyTypeList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      chanelList: [],
      typeList: [
        { id: 1, name: "Text" },
        { id: 2, name: "Text/Image" },
        { id: 3, name: "Text/Button" },
        { id: 6, name: "Image" },
        { id: 7, name: "Text/Image/Button" },
        { id: 8, name: "Custom flow" },
      ],
      responseType: 1,
    };
  },

  watch: {
    sameReplyAsNeutral: {
      deep: true,
      handler() {
        this.$emit("setSameReplyAsNuetral");
      },
    },
  },

  methods: {
    handleChangeType(value) {
      this.responseType = value;
      // Type Text
      if (this.responseType === 1) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
        };
        this.response.content = content;
      }

      // Type Text/Button
      if (this.responseType === 2) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
          Button: [
            {
              Id: 0,
              Label: "",
              Data: "",
              SortOrder: this.response.content.Button
                ? this.response.content.Button.length
                : 1,
              IsDefinedFlow: false,
              ActionTypeId: 1,
              ButtonTypeId: 1,
              language: this.languageActiveId,
              sameReplyAsNeutral: this.sameReplyAsNeutral,
            },
          ],
        };
        this.response.content = content;
      }

      // Type Text/Image
      if (this.responseType === 3) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
          Image: {
            Id: 0,
            ImageUrl: null,
            SortOrder: 1,
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
        };
        this.response.content = content;
      }

      // Type Image
      if (this.responseType === 4) {
        const content = {
          Image: [],
          ReplyType: value,
          language: this.languageActiveId,
          sameReplyAsNeutral: this.sameReplyAsNeutral,
        };
        this.response.content = content;
      }

      // Type Text/Image/Button
      if (this.responseType === 5) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
          Image: {
            Id: 0,
            ImageUrl: null,
            SortOrder: 1,
            language: this.languageActiveId,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
          Button: [
            {
              Id: 0,
              Label: "",
              Data: "",
              SortOrder: this.response.content.Button
                ? this.response.content.Button.length
                : 1,
              IsDefinedFlow: false,
              ActionTypeId: 1,
              ButtonTypeId: 1,
              language: this.languageActiveId,
              sameReplyAsNeutral: this.sameReplyAsNeutral,
            },
          ],
        };
        this.response.content = content;
      }

      // Type Custom
      if (this.responseType === 6) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.Language,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
        };
        this.response.content = content;
      }

      // Type Custom
      if (this.responseType === 17) {
        const content = {
          ReplyType: value,
          Text: {
            Id: 0,
            Text: "",
            language: this.Language,
            sameReplyAsNeutral: this.sameReplyAsNeutral,
          },
        };
        this.response.content = content;
      }

      // Type Product Reply
      if (this.responseType === 10) {
        const content = {
          ReplyType: value,
          Product: [],
          language: this.languageActiveId,
        };
        this.response.content = content;
      }

      // Type Condition
      if (this.responseType === 46) {
        let content = {
          ReplyType: value,
          Condition :{
            VariableId: 0,
            SymbolId: 0,
            Value: "",
            ReplyMainIntentIdTrue: 0,
            ReplyMainIntentIdFalse: 0,
            ReplyType: value,
            IntentConditionIdTrue: 0,
            IntentConditionIdFalse: 0,
            IntentReplyId: 0,
          },
        };
        this.response.content = content;
      }

      // Type User Input
      if (this.responseType === 47) {
        let content = {
          ReplyType: value,
          UserInput :{
            SaveResponseAs: 0,
            SuccessFormat: "",
            WrongFormat: "",
            Retry: "",
            ReplyType: value,
          }
        };
        this.response.content = content;
      }

      if (this.isEdit) {
        this.response.id == 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-box {
  background-color: #e9e9e9;
}
.text-main-color {
  color: #16274a;
}
.f-size-16 {
  font-size: 16px;
}
::v-deep .div-input {
  margin-bottom: 15px !important;
}
</style>
